import { render, staticRenderFns } from "./RoomCardVariant4.vue?vue&type=template&id=625c61b3&"
import script from "./RoomCardVariant4.vue?vue&type=script&lang=js&"
export * from "./RoomCardVariant4.vue?vue&type=script&lang=js&"
import style0 from "./RoomCardVariant4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports